import { qbHttp } from "./http";

export const listTemplates = (params = {}) =>
  qbHttp.request("api/qb/templates", { query: params });

export const getTemplate = (id) => qbHttp.request(`api/qb/templates/${id}`);

export const createTemplate = (body) =>
  qbHttp.request("api/qb/templates", { method: "POST", body });

export const updateTemplate = (id, body) =>
  qbHttp.request(`api/qb/templates/${id}`, { method: "PUT", body });

export const deleteTemplate = (id) =>
  qbHttp.request(`api/qb/templates/${id}`, { method: "DELETE" });
